// [ai] vega: a Vega-Lite spec (props.spec) over a query's rows (data.values at props.path; the spec's own data when there is no
// query). Follows the host's theme; renders SVG (crisp, themeable) through the interpreter runtime.
import { useEffect, useRef, useState } from "react";
import { useAtlas } from "../../sdk/react";
import { ErrorCard } from "../cards";
import { querySpec, rows, useHostQuery, Wait, type WidgetProps } from "./hooks";
import type { Schema } from "../props";
import { renderVega, type VegaSpec } from "./vega-runtime";
export const VEGA_PROPS: Schema = { spec: { type: "object", required: true }, path: { type: "string" } };
export function Vega({ spec }: WidgetProps) {
  const p = spec.props as { spec: VegaSpec; path?: string }; const host = useAtlas(); const el = useRef<HTMLDivElement>(null);
  const hasQuery = !!(spec.query && typeof spec.query === "object"); const q = useHostQuery<unknown>(querySpec(spec, "library"), hasQuery);
  const [dark, setDark] = useState(() => host.theme().scheme === "dark"); const [err, setErr] = useState<string | null>(null);
  useEffect(() => host.on("theme", t => setDark(t.scheme === "dark")), [host]);
  const values = hasQuery && q.data !== undefined ? rows(q.data, p.path) : undefined;
  useEffect(() => {
    const node = el.current; if (!node || (hasQuery && values === undefined)) return; let dead = false; let fin: (() => void) | null = null;
    renderVega(node, p.spec, values, dark).then(f => { if (dead) f(); else fin = f; }, e => { if (!dead) setErr((e as Error).message || String(e)); });
    return () => { dead = true; fin?.(); };
  }, [p.spec, values, dark, hasQuery]);
  if (q.error) return <ErrorCard text={q.error.message} />; if (err) return <ErrorCard text={`vega: ${err}`} />;
  return <div className="at-cat at-cat-vega">{hasQuery && q.data === undefined ? <Wait /> : null}<div className="at-vega" ref={el} /></div>;
}
